// Add navigation to native Rebuy bundles without replacing their purchase controls.
if (!customElements.get('rebuy-bundle-link')) {
  customElements.define('rebuy-bundle-link', class extends HTMLElement {
    connectedCallback() {
      this.observer = new MutationObserver(() => this.addLinks());
      this.observer.observe(this, { childList: true, subtree: true });
      this.addLinks();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    addLinks() {
      if (!this.dataset.url) return;
      this.querySelectorAll('.widget-type-dynamic-bundle .rebuy-bundle__actions-buttons').forEach(actions => {
        if (!actions.querySelector('button.rebuy-button') || actions.querySelector('.rebuy-bundle-shop-link')) return;
        const link = document.createElement('a');
        link.className = 'rebuy-bundle-shop-link';
        link.href = this.dataset.url;
        link.textContent = this.dataset.label;
        actions.append(link);
      });
    }
  });
}
